import Checkbox from '@root/joinroot.com/src/components/checkbox';
import Market from '@root/core/src/models/market';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import Select from '@root/core/src/components/select';
import { ButtonSize } from '@root/joinroot.com/src/components/button.js';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { P1 } from '@root/joinroot.com/src/components/text';

export default function CovidDrivingChart({
  isUS2019On,
  isUS2020On,
  selectedState,
  dataToDisplay,
  handleChangeSelectedState,
  handleChange2019,
  handleChange2020,
}) {
  const stateSelectOptions = Object.keys(dataToDisplay.states).map((stateId) => ({
    label: Market.MAPPING[stateId],
    value: stateId,
  }));

  if (!dataToDisplay) { return null; }
  return (
    <div css={styles.chartControls}>
      <div css={styles.stateSelectContainer}>
        <P1>See driving trends for</P1>
        <Select
          inputId={'state-select'}
          inputName={'state-select'}
          onChange={(value) => handleChangeSelectedState(value)}
          options={stateSelectOptions}
          placeholder={'Select a state'}
          selectBoxStyles={styles.selectBoxStyles}
          selectedValue={selectedState || ''}
        />
      </div>
      <div css={styles.yearCheckboxes}>
        <div css={styles.year2019}>
          <Checkbox
            checked={isUS2019On}
            id={'2019'}
            label={'2019'}
            onChange={(e) => handleChange2019(!!e.target.checked)}
            size={ButtonSize.LARGE}
          />
        </div>
        <Checkbox
          checked={isUS2020On}
          id={'2020'}
          label={'2020'}
          onChange={(e) => handleChange2020(!!e.target.checked)}
          size={ButtonSize.LARGE}
        />
      </div>
    </div>
  );
}

CovidDrivingChart.propTypes = {
  dataToDisplay: PropTypes.object,
  handleChange2019: PropTypes.func,
  handleChange2020: PropTypes.func,
  handleChangeSelectedState: PropTypes.func,
  isUS2019On: PropTypes.bool,
  isUS2020On: PropTypes.bool,
  selectedState: PropTypes.string,
};

const styles = StyleSheet.create({
  chartControls: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    width: '100%',
    maxWidth: 1200,
  },
  stateSelectContainer: {
    width: '100%',
  },
  selectBoxStyles: {
    marginTop: 8,
  },
  yearCheckboxes: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 30,
    '& > *': {
      height: 40,
    },
    ...Responsive.md({
      flexDirection: 'row',
      margin: '0 6% 0 8%',
      '& > * + *': {
        marginLeft: 40,
      },
    }),
  },
  year2019: {
    '& input[type="checkbox"]:not([disabled]):not([readonly]):checked + div.Checkbox__indicator': {
      backgroundColor: Colors.gray20(),
    },
  },
});

